import { Injectable } from '@angular/core';
import { StyleDescription } from '../models/new/style-description';

@Injectable({
	providedIn: 'root'
})
export class StyleDescriptionMapper {
	constructor() {}

	toStyleDescription(styleDescription: any) {
		return new StyleDescription({
			id: styleDescription.id,
			name: styleDescription.name
		});
	}
}
